import React from 'react';
import { expectations } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
export function Expectations() {
  return <section className="bg-cream py-16 sm:py-24" data-id="element-105" data-mp="9bf9a70yml4v">
      <div className="mx-auto max-w-5xl px-4" data-id="element-106" data-mp="9cqf0cdyu2ym">
        <SectionHeading eyebrow="What Should You Expect From a Practical Third Molar Reference?" title="A Useful Reference Should Help You Organize Information Beyond the First Read" intro={<>
              <p data-id="element-108" data-mp="16xmftmgtqnjv">
                I designed Third Molar Assessment Blueprint™ to be a resource you can revisit, not simply a document you read once and
                forget.
              </p>
              <p className="mt-3" data-id="element-109" data-mp="x7tcf8qu5eqp">As you evaluate the product, look for three things.</p>
            </>} data-id="element-107" data-mp="ea07y20kcwr7" />

        <ol className="mt-12 grid gap-8 md:grid-cols-3" data-id="element-110" data-mp="1kxdu7ob965ye">
          {expectations.map((e, i) => <li key={e.title} className="text-center" data-id="element-111" data-mp="1pri5ukvgr25t" data-mpi={i}>
              <span className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-navy font-display text-2xl font-bold text-white" data-id="element-112" data-mp="2sdvo6a9phccd">
                {i + 1}
              </span>
              <h3 className="mt-4 text-lg font-bold text-ink" data-id="element-113" data-mp="32500t3bwsl41">{e.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-114" data-mp="326b0os28h8pv">{e.text}</p>
            </li>)}
        </ol>

        <div className="mx-auto mt-12 max-w-2xl space-y-3 text-center text-[17px] leading-relaxed text-ink/85" data-id="element-115" data-mp="3b4n0nkozpiuz">
          <p data-id="element-116" data-mp="3651r6gc71s40">Those are the principles I used to develop Third Molar Assessment Blueprint™.</p>
          <p data-id="element-117" data-mp="3l3m3unqzkmal">
            I believe an educational reference should earn your confidence through the quality of its content, the clarity of its
            organization, and its usefulness over time.
          </p>
        </div>

        <div className="mt-10" data-id="element-118" data-mp="1qpuu7o8nq2f5">
          <CtaButton label="I Want a Reference I Can Use Again and Again" data-id="element-119" data-mp="1qr5w1iijl03m" />
        </div>
      </div>
    </section>;
}